import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { PageSection } from 'Components/Layout';
import {
  WorksheetImagesAndRemarksSection,
  WorksheetResultsSection,
  WorksheetTestedBySection,
} from 'Components/Worksheets/Core';
import { WorksheetRootComponent } from 'Components/Worksheets/Core/types';
import { useSelector } from 'react-redux';
import { pipe } from 'rxjs';
import ids from '../../../QestIds';
import { MaterialDryMassObtainedBy } from '../../types';
import { PreparationSection } from '../Shared';
import { DryMassImportSection, DryMassSection, WashingSection } from './Sections';
import { ResultsSection } from './Sections/ResultsSection';
const qestIds = [ids.wash.ASTM_D1140.rev2017];

let WashAstmD1140Worksheet: WorksheetRootComponent = ({ createWorksheetSelector }) => {
  const importedDryMass: boolean = useSelector(
    pipe(createWorksheetSelector!('Masses.MaterialDryMassObtainedBy'), (m) => m === MaterialDryMassObtainedBy.Imported)
  );

  return (
    <>
      <PageSection heading="Preparation">
        <PreparationSection />
      </PageSection>

      <PageSection heading="Measurements">
        {importedDryMass ? <DryMassImportSection /> : <DryMassSection />}
        <WashingSection />
      </PageSection>

      <PageSection>
        <WorksheetTestedBySection />
      </PageSection>

      <WorksheetResultsSection heading="Results">
        <ResultsSection />
      </WorksheetResultsSection>

      <PageSection heading="Images and Remarks">
        <WorksheetImagesAndRemarksSection />
      </PageSection>
    </>
  );
};

WashAstmD1140Worksheet.qestIds = qestIds;
WashAstmD1140Worksheet = withInjectedProps(WashAstmD1140Worksheet);

export { WashAstmD1140Worksheet };
export default WashAstmD1140Worksheet;
